(() => {
  const shapeFilterName = 'filter.p.m.custom.stone_shape';
  const legacyShapeFilterNames = [
    'filter.p.m.custom.center_diamond_shape',
    'filter.p.m.custom.stone_shape',
  ];
  const shapesByHandle = {
    round: 'Round',
    pear: 'Pear',
    oval: 'Oval',
    heart: 'Heart',
    radiant: 'Radiant',
    princess: 'Princess',
    marquise: 'Marquise',
    asscher: 'Asscher',
    emerald: 'Emerald',
    cushion: 'Cushion',
  };

  const normalizeHandle = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/%20/g, '-')
      .replace(/\s+/g, '-');

  const getLegacyShape = (url) => {
    const match = decodeURIComponent(url.pathname).match(/^\/collections\/engagement-rings\/([^/]+)\/?$/i);
    if (!match) return null;

    return shapesByHandle[normalizeHandle(match[1])] || null;
  };

  const buildFilterUrl = (sourceUrl, shape) => {
    const targetUrl = new URL('/collections/engagement-rings', window.location.origin);

    sourceUrl.searchParams.forEach((value, key) => {
      if (!legacyShapeFilterNames.includes(key)) targetUrl.searchParams.append(key, value);
    });
    targetUrl.searchParams.set(shapeFilterName, shape);

    return targetUrl;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, window.location.origin);
    const shape = getLegacyShape(url);
    if (!shape) return;

    event.preventDefault();
    window.location.href = buildFilterUrl(url, shape).href;
  });

  const currentUrl = new URL(window.location.href);
  const currentShape = getLegacyShape(currentUrl);
  if (currentShape) {
    window.location.replace(buildFilterUrl(currentUrl, currentShape).href);
  }
})();
